import {useMemo} from 'react';
import PropTypes from 'prop-types';
import {useSelector} from 'react-redux';
import {availableOptions} from '../../../../../../../../../store/reducers/reviews';
import {calculateEventHeight, calculateEventLeft, calculateEventTop} from '../../../../../utils/edReviewUtils';
import {COLUMN_GAP, OFFSET, SLOT_HEIGHT} from '../edReviewCalendarDaily';
import TemporarySelectedSlot from './temporarySelectedSlot';
import _isEmpty from 'lodash/isEmpty';

const PatientAssignableSlots = ({ colWidth, columnIndex, onSelectTime }) => {
  const options = useSelector(availableOptions);
  const columnAssignableSlots = useMemo(() => options?.[columnIndex], [columnIndex, options]);

  return options && !_isEmpty(columnAssignableSlots?.events) && columnAssignableSlots?.events.map((slot, slotIndex) => {
    return (
      <TemporarySelectedSlot
        session
        event={slot}
        availableSlot
        patientAssign
        id={`${slotIndex}`}
        colWidth={colWidth}
        columnIndex={columnIndex}
        onSelectTime={onSelectTime}
        key={`${slot.sessionId}${slotIndex}`}
        options={{
          top: calculateEventTop({
            isReview: false,
            offset: OFFSET,
            event: slot,
            slotHeight: SLOT_HEIGHT,
          }),
          left: calculateEventLeft({
            columnIndex: 0,
            offset: OFFSET,
            eventSlotWidth: colWidth,
            columnGap: COLUMN_GAP,
          }),
          height: calculateEventHeight({
            isReview: false,
            offset: OFFSET,
            event: slot,
            eventSlotHeight: SLOT_HEIGHT,
          }),
          width: colWidth,
        }}
      />
    );
  });
};

PatientAssignableSlots.propTypes = {
  colWidth: PropTypes.string,
  findEventIndex: PropTypes.func,
  dailySlots: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
};

export default PatientAssignableSlots;